import { inject, Injectable } from '@angular/core';
import { ComponentType } from '@angular/cdk/overlay';

import { DialogRef, DialogService } from '@hglobal/common';

import { InterviewViewerComponent } from './interview-viewer.component';
import { ImageDisplayData } from './models';

@Injectable()
export class InterviewViewerDialog {
  private _dialogService = inject(DialogService);

  open(image: ImageDisplayData) {
    const dialogRef = this._dialogService.open(
      InterviewViewerComponent,
      { image },
      { overlayBackdropClass: 'pu-interview-viewer-backdrop' },
    );
    const componentInstance
      = dialogRef.contentComponentInstance as unknown as InterviewViewerComponent;

    return {
      afterClosed: () => dialogRef.afterClosed(),
      onDownloadClicked$: componentInstance.downloadClicked$.asObservable(),
    };
  }
}
